import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState([]);

    // Uygulama açılınca kayıtlı sepeti getir
    useEffect(() => {
        const savedCart = localStorage.getItem('cart');
        if (savedCart) {
            setCart(JSON.parse(savedCart));
        }
    }, []);

    // Sepet değişince hafızaya kaydet
    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cart));
    }, [cart]);

    // Sepete Ekle
    const addToCart = (product, variation, quantity, price) => {
        setCart(prevCart => {
            // Ürün zaten sepette var mı? (Aynı ürün ve aynı varyasyon)
            const existingItemIndex = prevCart.findIndex(item => 
                item.product.id === product.id && 
                item.variation?.id === variation?.id
            );

            if (existingItemIndex > -1) {
                // Varsa miktarını arttır
                const newCart = [...prevCart];
                newCart[existingItemIndex].quantity = Number(newCart[existingItemIndex].quantity) + Number(quantity);
                return newCart;
            } else {
                // Yoksa yeni ekle
                return [...prevCart, { product, variation, quantity, price }];
            }
        });
    };

    // Miktar Güncelle
    const updateQuantity = (productId, variationId, newQuantity) => {
        setCart(prevCart => prevCart.map(item => {
            if (item.product.id === productId && item.variation?.id === variationId) {
                return { ...item, quantity: Number(newQuantity) };
            }
            return item;
        }));
    };

    // Sepetten Çıkar
    const removeFromCart = (productId, variationId) => {
        setCart(prevCart => prevCart.filter(item => 
            !(item.product.id === productId && item.variation?.id === variationId)
        ));
    };

    // Sepeti Temizle
    const clearCart = () => setCart([]);

    return (
        <CartContext.Provider value={{ cart, addToCart, removeFromCart, clearCart, updateQuantity }}>
            {children}
        </CartContext.Provider>
    );
};
